import dayjs from "dayjs";
import {usePage} from "@inertiajs/vue3";



export function decimal(value, digits = 2, options) {
    if(!value) {
        return value;
    }

    return value.toLocaleString('de-DE', {maximumFractionDigits: digits,  ...options});
}

export function date(date: string | null | Date, format: string = "DD.MM.YYYY") {
    return date ? dayjs(date).format(format) : date;
}


const page = usePage();
export function     t(key: string, vars = {}) {
    const keys = key.split('.');
    let translation = keys.reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : null), page.props.translations) ?? key;
    if (typeof translation === 'string') {
        Object.keys(vars).forEach(varKey => {
            const regex = new RegExp(`:${varKey}`, 'g');
            translation = translation.replace(regex, vars[varKey]);
        });
    }
    return translation;
}

const GEOHASH_BASE32 = "0123456789bcdefghjkmnpqrstuvwxyz";

export function encodeGeohash(latitude: number, longitude: number, precision = 5) {
    let latMin = -90;
    let latMax = 90;
    let lonMin = -180;
    let lonMax = 180;
    let hash = "";
    let bit = 0;
    let idx = 0;
    let evenBit = true;

    while (hash.length < precision) {
        if (evenBit) {
            const lonMid = (lonMin + lonMax) / 2;
            if (longitude >= lonMid) {
                idx = idx * 2 + 1;
                lonMin = lonMid;
            } else {
                idx = idx * 2;
                lonMax = lonMid;
            }
        } else {
            const latMid = (latMin + latMax) / 2;
            if (latitude >= latMid) {
                idx = idx * 2 + 1;
                latMin = latMid;
            } else {
                idx = idx * 2;
                latMax = latMid;
            }
        }

        evenBit = !evenBit;
        bit += 1;

        if (bit === 5) {
            hash += GEOHASH_BASE32[idx];
            bit = 0;
            idx = 0;
        }
    }

    return hash;
}

export function decodeGeohash(hash: string) {
    if (!hash) {
        return null;
    }

    let latMin = -90;
    let latMax = 90;
    let lonMin = -180;
    let lonMax = 180;
    let evenBit = true;

    for (const char of hash.toLowerCase()) {
        const idx = GEOHASH_BASE32.indexOf(char);
        if (idx === -1) {
            return null;
        }

        for (let bit = 4; bit >= 0; bit -= 1) {
            const mask = (idx >> bit) & 1;
            if (evenBit) {
                const lonMid = (lonMin + lonMax) / 2;
                if (mask === 1) {
                    lonMin = lonMid;
                } else {
                    lonMax = lonMid;
                }
            } else {
                const latMid = (latMin + latMax) / 2;
                if (mask === 1) {
                    latMin = latMid;
                } else {
                    latMax = latMid;
                }
            }
            evenBit = !evenBit;
        }
    }

    return {
        latitude: (latMin + latMax) / 2,
        longitude: (lonMin + lonMax) / 2,
    };
}
